import { createFileRoute } from '@tanstack/react-router'
import { StaffEkonomi } from '../../../../components/StaffEkonomi'

export const Route = createFileRoute('/desa/$slug/dashboard/ekonomi')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <StaffEkonomi desaId={desaId} />
  },
})
